import { StyledProps } from '@components/3rd-party/mui'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import React, { ElementType } from 'react'
import { PrimaryButton } from './PrimaryButton'
import { SecondaryButton } from './SecondaryButton'
import { useTranslation } from 'react-i18next'
import { useObserver } from 'mobx-react-lite'
import { Button, Grid, makeStyles, MuiThemeProvider } from '@material-ui/core'
import { lightTheme } from '@core/system/theme'
import CloseIcon from '@material-ui/icons/Close'

export interface IEnhancedConfirmationDialog extends StyledProps {
  open?: boolean
  loading?: boolean
  handleClose?: any
  title?: any
  message?: any
  messageEle?: ElementType
  handleConfirm?: any
  proceedButtonTitle?: string
  backButtonTitle?: string
  cancelButtonTitle?: string
  hideCancelButton?: boolean
  hideConfirmButton?: boolean
  showBackButton?: boolean
  handleBack?: any
  bodyContent?: any
}

const useStyles = makeStyles(theme => ({
  cancelBtn: {
    width: 120,
    height: 34,
    marginRight: 10
  },
  confirmBtn: {
    width: 120,
    height: 34,
    marginLeft: '24px !important'
  },
  closeIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  hiddenBtn: {
    width: 0,
    height: 0,
    padding: 0,
    display: 'none'
  },
  closeIcon: {
    cursor: 'pointer'
  }
}))

export const EnhancedConfirmationDialog: React.FC<IEnhancedConfirmationDialog> = ({
  open,
  handleClose,
  title,
  message,
  handleConfirm,
  proceedButtonTitle,
  cancelButtonTitle,
  backButtonTitle,
  loading,
  hideCancelButton,
  hideConfirmButton,
  showBackButton = false,
  handleBack,
  bodyContent
}) => {
  return useObserver(function useHook() {
    const { t } = useTranslation()
    const classes = useStyles()
    return (
      <MuiThemeProvider theme={lightTheme}>
        <Dialog open={open as boolean} onClose={handleClose} disableEscapeKeyDown>
          <DialogTitle id='alert-dialog-title'>
            <Grid container>
              <Grid item xs={11}>
                {title || ''}
              </Grid>
              <Grid item xs={1} className={classes.closeIconContainer}>
                <CloseIcon className={classes.closeIcon} onClick={handleClose} />
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id='alert-dialog-description'
              {...(message
                ? {
                    dangerouslySetInnerHTML: { __html: message }
                  }
                : {})}
            >
              {bodyContent}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {/* Added this hidden button to avoid unnecesary focus on radio button */}
            <Button className={classes.hiddenBtn} />
            {showBackButton ? (
              <PrimaryButton onClick={handleBack} disabled={loading}>
                {backButtonTitle ? backButtonTitle : t('common.label.back', 'Back')}
              </PrimaryButton>
            ) : null}
            {!hideCancelButton ? (
              <SecondaryButton
                className={classes.cancelBtn}
                variant='outlined'
                onClick={() => {
                  handleClose?.()
                }}
                disabled={loading}
              >
                {cancelButtonTitle ?? t('bb.common.label.cancel', 'Cancel')}
              </SecondaryButton>
            ) : null}
            {!hideConfirmButton ? (
              <PrimaryButton
                className={classes.confirmBtn}
                onClick={handleConfirm}
                loading={loading}
                disabled={loading}
              >
                {proceedButtonTitle ?? t('common.label.continue', 'Continue')}
              </PrimaryButton>
            ) : null}
          </DialogActions>
        </Dialog>
      </MuiThemeProvider>
    )
  })
}
